import { Box, Button } from '@chakra-ui/react';
import React from 'react';
import HeaderWithCloseIcon from '../../../components/common/HeaderWithCloseIcon';
import Badges from '../../../components/V2/Badges/Badges';
import { useNavigate } from 'react-router-dom';

const BadgesPage = () => {
	const navigate = useNavigate();
	return (
		<Box minH="100%" pb="72px" bgColor={'#FFF9E5'}>
			<Box display={{ lg: 'none' }} bg="white">
				<HeaderWithCloseIcon title="My Badges" closeIconPath="/dashboard" />
			</Box>
			<Badges />
			<Box
				h="72px"
				width={'100%'}
				px="16px"
				py="12px"
				bgColor={'#fff'}
				boxShadow={'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'}
				position={'fixed'}
				bottom={'0px'}
				display={{ md: 'none' }}
			>
				<Button
					variant={'primary'}
					width={'100%'}
					size={'lg'}
					bgColor={'#4358F6'}
					textStyle={'btn-lg'}
					letterSpacing={'1.25px'}
					onClick={() => {
						//create resume
						navigate('/dashboard');
					}}
				>
					Start Practicing
				</Button>
			</Box>
			<Box mx="auto" textAlign="center" display={{ base: 'none', md: 'block' }}>
				<Button
					variant={'primary'}
					size={'lg'}
					bgColor={'#4358F6'}
					textStyle={'btn-lg'}
					letterSpacing={'1.25px'}
					onClick={() => {
						//create resume
						navigate('/dashboard');
					}}
				>
					Start Practicing
				</Button>
			</Box>
		</Box>
	);
};

export default BadgesPage;
